// eslint-disable-next-line import/no-anonymous-default-export
export default (dispose = [], action) => {
  switch (action.type) {
    case "GET_ALL_DISPOSED":
      return action.payload;

    case "DISPOSE_ASSET":
      return [...dispose, action.payload];

    default:
      return dispose;
  }
};
